import { render } from "./ArticleList.vue?vue&type=template&id=814fe77e&scoped=true"
import script from "./ArticleList.vue?vue&type=script&lang=js"
export * from "./ArticleList.vue?vue&type=script&lang=js"

import "./ArticleList.vue?vue&type=style&index=0&id=814fe77e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814fe77e"]])

export default __exports__